import { stringSchema, yearSchema } from '@common/neo.tax';
import { z } from 'zod';

import { TaxAuthority, DocumentType, DocumentStatus } from '@neo.tax/shared/graphql';

export const TaxDocumentSchema = z.object({
  fiscalYearId: stringSchema,
  taxYear: yearSchema,
  fileName: stringSchema.nullable().optional(),
  url: stringSchema.nullable().optional(),
  documentType: z.enum(DocumentType),
  taxAuthority: z.enum(TaxAuthority),
  status: z.enum(DocumentStatus).optional(),
  missingInformation: stringSchema.array().nullable().optional(),
  generatedDate: stringSchema.nullable().optional(),
});

export type TaxDocument = z.infer<typeof TaxDocumentSchema>;

export const FederalRdTaxCreditDocumentsSchema = z.object({
  fiscalYearId: stringSchema,
  taxYear: yearSchema,
  taxAuthority: z.enum(TaxAuthority),
  taxCreditFormFileName: stringSchema.nullable(),
  taxCreditFormUrl: stringSchema.nullable(),
  taxCreditFormDocumentType: z.enum(DocumentType),
  taxCreditFormStatus: z.enum(DocumentStatus),
  taxCreditFormMissingInformation: stringSchema.array().nullable(),
  taxCreditFormGeneratedDate: stringSchema.nullable().optional(),
  taxWriteUpPdfFileName: stringSchema.nullable(),
  taxWriteUpPdfUrl: stringSchema.nullable(),
  taxWriteUpPdfDocumentType: z.enum(DocumentType),
  taxWriteUpStatus: z.enum(DocumentStatus),
  taxWriteUpMissingInformation: stringSchema.array().nullable(),
  taxWriteUpGeneratedDate: stringSchema.nullable().optional(),
});

export type FederalRdTaxCreditDocuments = z.infer<typeof FederalRdTaxCreditDocumentsSchema>;
